<div *ngIf="platform.is('ios') || platform.is('desktop')" class="poweredby poweredby-ios">
  <p class="poweredby-text">powered by</p>
  <img class="poweredby-img" [src]="distributor?.powered_by_logo_dark_theme">
</div>

<div *ngIf="platform.is('android')" class="poweredby poweredby-android">
  <p class="poweredby-text">powered by</p>
  <img class="poweredby-img" [src]="distributor?.powered_by_logo_dark_theme">
</div>